import styled from 'styled-components';
import { shade } from 'polished';

export const Conteiner = styled.div`

  padding-bottom: 90px;

`;
